import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-mode-section',
  templateUrl: './power-mode-section.component.html',
  styleUrls: ['./power-mode-section.component.scss']
})
export class PowerModeSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
